module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', [_c('org-nav')], 1), _vm._v(" "), _c('section', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('tabela-inscritos', {
    attrs: {
      "lista": _vm.listaInscritos
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h2', [_vm._v("Lista Inscritos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11df7509"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/org/ListaInscritos.vue
// module id = 250
// module chunks = 1